<script setup lang="ts">
import gif from "@/assets/imgs/enlaceloading.gif";

interface LoadingModalProps<T> {
  when: boolean;
  message?: string | number;
}

withDefaults(defineProps<LoadingModalProps<string | number>>(), {
  message: "Cargando...",
});
</script>

<script lang="ts">
export default {
  name: 'LoadingModal'
}
</script>

<template>
  <Transition name="loading">
    <div v-if="when" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div class="text-center">
        <img :src="gif" alt="Cargando" class="enlace-loading invert mx-auto" />
        <span class="text-white text-lg mt-4 block">{{ $props.message }}</span>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.enlace-loading {
  width: 100px;
  height: 100px;
}
.loading-enter-active,
.loading-leave-active {
  transition: opacity 0.5s ease;
}

.loading-enter-from,
.loading-leave-to {
  opacity: 0;
}
</style>
